import { useContext } from "react";
import { Navigate, Outlet } from "react-router-dom";
import { AppContext } from "../Contexts/AppContext";

export const ProtectedRoute = ({children}: any) => {
    const appConfig = useContext(AppContext);
    if (!appConfig.profile) {
        return <Navigate to="/" />;
    }
    return children ? children : <Outlet />;
};
